<div class="cockpit-view">
  <h3 translate>m1.sprint5.cockpit.card.chart.grafischerModellcheck.qqPlot.diagramm</h3>
  <div id="svgChartQqPlot" style="padding-bottom: 50px;" class="pdt-30 width-max-100-perc"></div>
</div>
